import { ExcelService } from './../../../services/excel.service';
import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { School } from './../../../models/school';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BusEvent } from './../../../models/bus-event';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';
import { Router } from '@angular/router';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-bus-event-datatable',
  templateUrl: './bus-event-datatable.component.html',
  styleUrls: ['./bus-event-datatable.component.css']
})
export class BusEventDatatableComponent implements OnInit, OnDestroy {

  filter = {
    clientId: '',
    schoolId: '',
    busIds: [],
    alertId: '',
    dateTimeInterval: [
      new Date(moment().format('YYYY-MM-DD 00:00:00')),
      new Date(moment().format('YYYY-MM-DD 23:59:59'))
    ],
    isAdmin: false
  };
  staticFilter: any;

  clients: any[];
  schools: any[];
  buses: any[];
  alerts: any[];
  pnotify = undefined;

  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public alertsData: Array<Select2OptionData>;
  // ----- Start MultiSelect -----------
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  multiSelectSettingsSchool: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: false,
    showUncheckAll: false,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block',
    selectionLimit: 1,
    autoUnselect: true
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'éléments sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // ----- End MultiSelect -----------

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  busEvents: any[];
  isResponsible = false;
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.filter.isAdmin = (this.roleService.getRole('ROLE_ADMIN')) ? true : false;
    this.initClientSelect();
    this.initAlertSelect();
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit(): void {
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/busEvent',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.busEvents = resp.data;
          const dta = [];
          this.busEvents.forEach(busEvent => {
            dta.push({
              id: busEvent.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${busEvent.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              busSchoolName: busEvent.Bus.School.name,
              busName: busEvent.Bus.name,
              alertName: busEvent.Alert.name,
              time: moment.utc(busEvent.time).format('DD/MM/YYYY à HH:mm:ss'),
              message: busEvent.message,
              actions: `
                <button class="btn btnAction btnDelete" data-busevent-id="${busEvent.id}">
                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                </button>
              `
            });
          });

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'busEvent_' + aData.id);
      },
      columns: [
        { data: 'checkbox' },
        { data: 'busSchoolName' },
        { data: 'busName' },
        { data: 'alertName' },
        { data: 'time' },
        { data: 'message' },
        { data: 'actions' },
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('buseventId'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
        this.initSchoolSelect();
      });
    }
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    this.staticFilter.dateTimeInterval = [
      moment(this.staticFilter.dateTimeInterval[0]).format('YYYY-MM-DD HH:mm:ss'),
      moment(this.staticFilter.dateTimeInterval[1]).format('YYYY-MM-DD HH:mm:ss')
    ];
  }
  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      // this.filter.schoolId = schools.length ? schools[0].id : '';
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      this.schoolsData = array1.concat(array2);
      // this.initBusSelect();
      this.buses = [];
    });
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busIds = [];
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      for (let i = 0; i < this.buses.length; i++) {
        this.filter.busIds.push(this.buses[i].id);
      }
      this.onFilter();
    });
  }

  initAlertSelect() {
    this.filter.alertId = '';
    let params = new HttpParams({
      fromObject: {
        isAdmin: this.filter.isAdmin + ''
      }
    });
    this.http.get(
      '/api/alert/lookup',
      { params }

    ).subscribe((alerts: any[]) => {
      this.alerts = alerts;
      const array1 = [{ id: '', text: 'Choisir un type' }];
      const array2 = this.alerts.map(function (alert, index) {
        return { id: alert.id, text: alert.name };
      });
      this.alertsData = array1.concat(array2);
    });
  }
  alertChanged(e: any) {
    this.filter.alertId = e.value;
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onExport(id) {
    this.http.post(
      '/api/busEvent',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      const data = [
        [
          'École',
          'Bus',
          'Type d\'alerte',
          'Date/Heure',
          // 'Position',
          'Message'
        ]
      ];
      for (let i = 0; i < resp.data.length; i++) {
        data.push([
          resp.data[i].Bus.School.name,
          resp.data[i].Bus.name,
          resp.data[i].Alert.name,
          resp.data[i].time,
          // resp.data[i].lat + ', ' + resp.data[i].lng,
          resp.data[i].message
        ]);
      }
      this.excelService.exportAsExcelFile(data, 'alertes_bus');
    });
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/busEvent/' + id)
      .subscribe(
        result => {
          document.getElementById('busEvent_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    this.staticFilter.dateTimeInterval = [
      moment(this.staticFilter.dateTimeInterval[0]).format('YYYY-MM-DD HH:mm:ss'),
      moment(this.staticFilter.dateTimeInterval[1]).format('YYYY-MM-DD HH:mm:ss')
    ];
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/bus-event/bus-event-datatable/bus-event-datatable.component.ts